
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 90 40.08"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":"45.33","y1":"40.52","x2":"45.33","y2":".44","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#6d83d5"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#8342dc"}})])]),_c('path',{attrs:{"d":"M34.55 6.31a20 20 0 100 28.34L59.37 9.83l.14-.13a15.25 15.25 0 110 21.56l-5.67-5.65A2.4 2.4 0 0050.45 29l6.07 6A20 20 0 0084.46 6.31a20 20 0 00-27.52-.78L31.16 31.27a15.25 15.25 0 110-21.57l5.71 5.72a2.4 2.4 0 003.4-3.42z","transform":"translate(-.33 -.44)","fill":"url(#a)"}})])
          )
        }
      }
    